import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { compose } from 'recompose';
import { withStyles, FormControl, InputLabel } from '@material-ui/core';
import makeSelectorInstance from '../../reference/makeSelectorInstance';
import { getSelectedElementFontColor } from '../../banner/bannerSelectors';
import { setElementColor } from '../../banner/bannerActionsCreators';
import { styles } from '../propertyEditorStyles';
import RgbaColorPicker from '../../components/ColorPicker/RgbaColorPicker';
import { getSelectedElementId } from '../../temporary-status/temporaryStatusDucks';

class ElementFontColor extends React.Component {
  state = {};

  static getDerivedStateFromProps(nextProps) {
    return { shrink: nextProps.classes.labelShrink };
  }

  onColorChange = color => {
    const { setElementColor, id } = this.props;
    setElementColor({ color, id });
  };

  render() {
    const { id, color } = this.props;

    return (
      <FormControl fullWidth>
        <InputLabel shrink classes={this.state}>
          <FormattedMessage id="properties.text.color" />
        </InputLabel>
        <RgbaColorPicker
          key={id}
          enableAlpha={false}
          value={color}
          initialColor={color}
          onChange={this.onColorChange}
        />
      </FormControl>
    );
  }
}

const makeStateToProps = () => state => ({
  id: makeSelectorInstance(getSelectedElementId)(state),
  color: makeSelectorInstance(getSelectedElementFontColor)(state),
});

const dispatchToProps = {
  setElementColor,
};

export default compose(
  connect(
    makeStateToProps,
    dispatchToProps,
  ),
  withStyles(styles),
)(ElementFontColor);
